import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    x: -20
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.5,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};
export function IdealClientSection() {
  const criteria = ['Eres dueño o director de una clínica médica, dental o de especialidad', 'Tienes al menos 1 doctor o especialista atendiendo pacientes', 'Quieres dejar de depender de referencias y boca a boca', 'Estás listo para invertir en un sistema de adquisición de pacientes predecible', 'Quieres llenar tu agenda con pacientes que realmente pagan'];
  return <section className="py-20 md:py-24 px-5 sm:px-6 md:px-8 bg-carbon" data-id="element-255">
      <div className="max-w-4xl mx-auto" data-id="element-256">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="mb-12 md:mb-16 text-center md:text-left" data-id="element-257">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-gold mb-4" data-id="element-258">
            ¿Es Esto Para Ti?
          </h2>
          <p className="text-xl md:text-2xl text-white font-medium" data-id="element-259">
            Este sistema es para ti si...
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="space-y-4" data-id="element-260">
          {criteria.map((item, index) => <motion.div key={index} variants={itemVariants} className="flex items-start bg-white/5 p-5 md:p-6 rounded-lg border border-white/5 hover:border-emerald/30 transition-colors duration-300" data-id="element-261">
              <CheckCircle className="w-6 h-6 md:w-7 md:h-7 text-emerald mr-4 flex-shrink-0 mt-0.5" data-id="element-262" />
              <span className="text-gray-200 text-base md:text-lg font-medium leading-snug" data-id="element-263">
                {item}
              </span>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}